// Router
import { replace } from "react-router-redux";
import { BASE_URL } from "../../config/constants";
import { hideSpinner, showSpinner } from "../../services/spinner.ducks";
// API
import { get } from "../../services/api";

export const navigateTo = (path) => (dispatch, getState) => {
  const {
    router: {
      location: { pathname }
    }
  } = getState();
  const correctPath = `${BASE_URL}${path}`;
  if (correctPath !== pathname) {
    dispatch(replace(correctPath));
  }
};

export const checkOpenPayment = () => async (dispatch, getState) => {
  try {
    // Spinner currently not needed, the whole dialogue is a spinner itself. 
    // Will be removed with the upcoming success / failed state. ;)

    //dispatch(showSpinner());

    const { data } = await dispatch(get(`/payment/checkOpenpayment`));

    //dispatch(hideSpinner());
    return data;
  } catch (error) {
    dispatch(hideSpinner());
  }
};
